import { useMemo } from 'react'
import { formatCommonAmount } from '../../util/formatAmount'
import CheckBoxCustom from '../atoms/checkbox/CheckBox'
import { formatCommonDate } from '../../util/formatDateAndTime'
import { getVendorBusinessTypes } from '../../util/businessTypes'
import PackageSummary from '../../pages/vendors-list/Modals/PackageSummary'

import styles from './index.module.scss'

const ADD_VENDOR_SUMMARY_FIELDS = [
	{ key: 'businessName', heading: 'Business Name' },
	{ key: 'businessTypes', heading: 'Business Type' },
	{ key: 'email', heading: 'Vendor Email' },
	{ key: 'phone', heading: 'Vendor Phone' },
	{ key: 'website', heading: 'Website' },
	{ key: 'instagramLink', heading: 'Instagram Link' },
	{ key: 'tiktokLink', heading: 'Tiktok Link' },
	{ key: 'facebookLink', heading: 'Facebook Link' },
	{
		key: 'quote',
		heading: 'Quote Amount',
		format: (v) => formatCommonAmount(v),
	},
	{
		key: 'deposit',
		heading: 'Deposit Amount',
		format: (v) => formatCommonAmount(v),
	},
	{
		key: 'paymentDueDate',
		heading: 'Payment Due Date',
		format: (v) =>
			formatCommonDate(v?.toISOString?.() ? v.toISOString() : v),
	},
	{ key: 'status', heading: 'Status' },
]

export default function AddVendorDetails({
	vendor,
	setVendor,
	selectedPackage,
}) {
	const businessTypes = getVendorBusinessTypes(vendor).join(', ')
	const summary = useMemo(() => {
		if (!vendor || !Object.keys(vendor).length) return []
		return ADD_VENDOR_SUMMARY_FIELDS.map(({ key, heading, format }) => {
			const value = key === 'businessTypes' ? businessTypes : vendor[key]
			return {
				heading,
				value: value ? (format ? format(value) : value) : '--',
			}
		})
	}, [vendor, businessTypes])
	return (
		<>
			<div className={styles.summary}>
				<h4>Summary</h4>
				<div className="">
					<ul>
						{summary.map((item) => (
							<li key={item.heading}>
								<span className={styles.heading}>
									{item.heading}
								</span>
								<span className={styles.value}>
									{item.value}
								</span>
							</li>
						))}
					</ul>
					<PackageSummary selectedPackage={selectedPackage} />
					<div className={styles.requirements}>
						<p className={styles.heading}>Notes</p>
						<p className={styles.value}>{vendor?.notes || '--'}</p>
					</div>
				</div>
			</div>
			<CheckBoxCustom
				label="I agree to share my contact information with this vendor"
				checked={vendor?.checked || false}
				onChange={(e) =>
					setVendor((prev) => ({
						...prev,
						checked: e.target.checked,
					}))
				}
			/>
		</>
	)
}
